module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fetch_keyword_data_failure":"Fetching keyword data has failed.","not_positioned":"page not positioned"},"fr":{"fetch_keyword_data_failure":"La récupération des données du mot clé a échoué.","not_positioned":"page non positionnée"},"de":{"fetch_keyword_data_failure":"Keyword-Daten konnten nicht abgerufen werden.","not_positioned":"Seite nicht positioniert"}}')
  delete Component.options._Ctor
}
